import { ChatAppRequest, IUploadResponse } from "./models";
import { getEncodedCurrentURL, strToDate } from "../util_glob";
import { toast } from "react-toastify";
import {
    gselectedgroup,
    greindexparams,
    gingestioniteminfo,
    gloggedinuser,
    gtranscriptentry,
    gtranscriptobject,
    gtranscriptpublish,
    gdiff,
    gnewgroup,
    gChatlogItem,
    gfile,
    gautoparagraphresult,
    gautoparagraph,
    gdiffresponse,
    gailinks,
    gfanalyse,
    gjsonprop,
    gqasimplified,
    qconvoupload,
    gComplogItem,
    livecachemapitem,
    livecachemap,
    livecacheactions,
    SaveOptions,
    ownersProps,
    gLicense
} from "../interfaces";
import { getHeaderG, getHeaderGS } from "./qpi";
import { IObjectWithKey } from "@fluentui/react";
import {getEmptyHeaders, fetchTaskStatus, removeTaskIdFromLocal, wait } from "../util_glob";

export async function chatApi(request: ChatAppRequest, loggedInUser: gloggedinuser): Promise<Response> {
    return await fetch(`/chat`, {
        method: 'POST',
        headers: getEmptyHeaders(loggedInUser),
        body: JSON.stringify(request)
    });
}

export async function deleteFile(fileName: string, fileid: string, header: any, companyid: string, group_id:string, listRefreshRequest?: (fileids?: string, isfromchat?: boolean, gid?: string) => void): Promise<IUploadResponse> {
    const toastId = toast("Deleting Files. Prepping...", { autoClose: false });
    const response = await fetch("/file_remove", {
        method: "POST",
        headers: header,
        body: JSON.stringify({ fileName: fileName, fileid: fileid, companyid: companyid, group_id: group_id })
    });
    if (!response.ok) console.log(`Delete File Failed: ${response.statusText}`);

    toast.update(toastId, { render: "Deleting...", autoClose: false });

    const dataResponse: any = await response.json();
    const taskId = dataResponse.task_id;

    const wait = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
    const fetchDelTaskStatus = async (taskId: string) => {
        const statusResponse = await fetch(`/task-status/${taskId}`);
        if (!statusResponse.ok) console.log(`Fetching Task Status Failed: ${statusResponse.statusText}`);

        return await statusResponse.json();
    };
    let taskCompleted = false;
    let taskResult = false;
    let taskMessage = "";

    while (!taskCompleted) {
        await wait(3000);
        const chkResp = await fetchDelTaskStatus(taskId);
        import.meta.env.DEV === true && console.log("deleteFileApi¦Next Response", chkResp);

        if (chkResp.status == "success" || chkResp.status == "partial" || chkResp.status == "error") {
            if (chkResp.status == "success" || chkResp.status == "partial") {
                taskResult = true;
                taskMessage = chkResp.message;
            } else {
                taskResult = false;
                taskMessage = chkResp.message;
            }
            taskCompleted = true;
            toast.update(toastId, {
                render: chkResp.message,
                autoClose: 2000
            });
        } else {
            import.meta.env.DEV === true && console.log("Toast", `Deleting File...`);
            if (listRefreshRequest) listRefreshRequest();

            toast.update(toastId, {
                render: chkResp.message
            });
        }
    }

    const uplResponse: IUploadResponse = { success: taskResult, message: taskMessage };
    return uplResponse;
}

export async function getSiteLinks(urlString: string, ai_instr: string, loggedInUser: gloggedinuser, space_id:string): Promise<gailinks> {
    const response = await fetch("/get_web_links", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            url: urlString,
            ai_instr: ai_instr,
            uid: loggedInUser.userId,
            gid: space_id
        })
    });
    if (!response.ok) console.log(`Add URL File Failed: ${response.statusText}`);
    return response.json();
}

export async function dataExtractionApi(props: greindexparams, progressCallback?: (fileids?: string) => void): Promise<IUploadResponse> {
    const response = await fetch("/invoice_extraction", {
        method: "POST",
        headers: props.header,
        body: JSON.stringify({
            filestring: props.fileString,
            company: props.company,
            userid: props.userId,
            filespace: props.selectedGroup.selectionId,
            sectionoverlap: props.selectedGroup.sectionoverlap,
            maxsectionlength: props.selectedGroup.maxsectionlength,
            sentencesearchlimit: props.selectedGroup.sentencesearchlimit,
            modstring: props.modString,
            idstring: props.idString,
            usedocintel: props.selectedGroup.usedocintel,
            extractionfieldlist: props.selectedGroup.extractionfieldlist,
            assistanttype: props.selectedGroup.assistanttype,
            doc_page_len: props.doc_page_len
        })
    });

    if (!response.ok) console.log(`‹errr_data_extract› ${response.statusText}`);

    const dataResponse: any = await response.json();
    const taskId = dataResponse.task_id;

    let itterCounter = 0;

    let taskCompleted = false;
    let taskResult = false;

    let taskMessage = "";
    let taskMessagePrev = "-1";

    const toastId = toast.loading("Extracting Invoice Details...", { autoClose: false, closeOnClick: true, closeButton: true });

    if (progressCallback) progressCallback();


    while (!taskCompleted) {
        itterCounter++;
        await wait(2000);
        const chkResp = await fetchTaskStatus(taskId);
        if (chkResp.status == "success" || chkResp.status == "partial" || chkResp.status == "error") {
            if (chkResp.status == "success" || chkResp.status == "partial") {
                taskResult = true;
                taskMessage = chkResp.message;
            } else {
                taskResult = false;
                taskMessage = chkResp.message;
            }
            taskCompleted = true;
            toast.update(toastId, {
                render: chkResp.message,
                autoClose: 7000
            });
        } else {
            import.meta.env.DEV === true && console.log("Toast", `Extracting Invoice Details...`);
            if (chkResp.fileCount !== undefined) {
                try {
                    let progress = chkResp.progressCount / chkResp.fileCount;
                    taskMessage = chkResp.message;
                    toast.update(toastId, {
                        render: `Extracting Invoice Details... ${chkResp.progressCount} of ${chkResp.fileCount} Done`
                    });
                } catch {
                    taskMessage = chkResp.message;
                    toast.update(toastId, {
                        render: `Extracting Invoice Details... ${chkResp.progressCount} of ${chkResp.fileCount} Done`
                    });
                }
            }

            if (itterCounter % 10 === 0 || itterCounter % 10 === 5 || itterCounter < 5) if (progressCallback) progressCallback();
        }

        if (taskMessagePrev !== taskMessage && progressCallback) progressCallback();

        taskMessagePrev = taskMessage;
    }

    const uplResponse: IUploadResponse = { success: taskResult, message: taskMessage };
    return uplResponse;
}

export async function saveTranscriptionDraft(
    selectedGroup: gselectedgroup,
    loggedInUser: gloggedinuser,
    transcript: gtranscriptentry[],
    transcriptKey: string,
    transcriptname: string,
    fid: string | number
) {
    await fetch(`/qSaveTranscriptionDraft`, {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify({
            groupid: selectedGroup.selectionId,
            userid: loggedInUser.userId,
            transcriptKey: transcriptKey,
            transcript: transcript,
            transcriptname: transcriptname,
            fid: fid
        })
    });
}

export async function qUploadCCAConvo(trnscptPbls: qconvoupload, progressCallback?: (fileids?: string) => void) {
    const toastId = toast("Adding Conversation to Knowledge..", { autoClose: false });
    setTimeout(() => {
        if (!isRequestFinished) if (progressCallback) progressCallback();
    }, 2000);

    const response = await fetch(`/kgnf_upload_conversation`, {
        method: "POST",
        headers: getHeaderG(trnscptPbls.loggedInUser),
        body: JSON.stringify({
            content: trnscptPbls.convo,
            containername: trnscptPbls.convoName,
            userid: trnscptPbls.loggedInUser.userId,
            groupid: trnscptPbls.selectedGroup.selectionId,
            companyid: trnscptPbls.selectedGroup.companyid,
            sectionoverlap: trnscptPbls.selectedGroup.sectionoverlap,
            maxsectionlength: trnscptPbls.selectedGroup.maxsectionlength,
            sentencesearchlimit: trnscptPbls.selectedGroup.sentencesearchlimit,
            invoicesgroup: trnscptPbls.selectedGroup.invoicesgroup,
            usedocintel: trnscptPbls.selectedGroup.usedocintel,
            forceocr: trnscptPbls.selectedGroup.forceocr,
            assitanttype: trnscptPbls.selectedGroup.assistanttype,
            contenttype_config: trnscptPbls.selectedGroup.contenttype_config,
            aiquestionslang: trnscptPbls.selectedGroup.aiquestionslang,
            urllinkextraction: trnscptPbls.selectedGroup.urllinkextraction,
            perchunkmeta: trnscptPbls.selectedGroup.perchunkmeta,
            convo_config: trnscptPbls.selectedGroup.convo_config,
            oid: trnscptPbls.selectedGroup.oid
        })
    });
    let isRequestFinished = false;

    if (!response.ok) console.log(`Uploading_Files_Failed: ${response.statusText}`);

    const dataResponse: any = await response.json();
    import.meta.env.DEV === true && console.log("pldFlAp¦Init_Response4", dataResponse);

    const taskId = dataResponse.task_id;
    let taskCompleted = false;
    let taskResult = false;
    let taskMessage = "";
    let taskMessagePrev = "-1";
    let itterCounter = 0;

    while (!taskCompleted) {
        itterCounter++;
        // publishTranscriptDraft
        await wait(8000);
        const chkResp = await fetchTaskStatus(taskId);

        import.meta.env.DEV === true && console.log("pldFlAp¦Next_Response", chkResp);

        if (chkResp.status == "success" || chkResp.status == "partial" || chkResp.status == "error") {
            if (chkResp.status == "success" || chkResp.status == "partial") {
                taskResult = true;
                taskMessage = chkResp.message;
            } else {
                taskResult = false;
                taskMessage = chkResp.message;
            }
            taskCompleted = true;
            toast.update(toastId, {
                render: chkResp.message,
                autoClose: 7000
            });
        } else {
            if (chkResp.filecount !== undefined) {
                try {
                    let progress = chkResp.progresscount / chkResp.filecount;
                    taskMessage = `Processing Files... ${chkResp.progresscount} of ${chkResp.filecount} Done`;
                    toast.update(toastId, {
                        render: taskMessage
                    });
                } catch {
                    taskMessage = `Processing Files... ${chkResp.progresscount} of ${chkResp.filecount} Done`;
                    toast.update(toastId, {
                        render: taskMessage
                    });
                }
            }

            if (itterCounter % 2 === 0 || itterCounter % 10 === 5 || itterCounter < 5) if (progressCallback) progressCallback();
        }
        if (taskMessagePrev !== taskMessage) if (progressCallback) progressCallback();

        taskMessagePrev = taskMessage;
    }
    removeTaskIdFromLocal(taskId);
    const uplResponse: IUploadResponse = { success: taskResult, message: taskMessage };
}

export async function publishTranscriptDraft(trnscptPbls: gtranscriptpublish, progressCallback?: (fileids?: string) => void) {
    const toastId = toast.loading("Uploading Files...", { autoClose: false, closeOnClick: true, closeButton: true });
    setTimeout(() => {
        if (!isRequestFinished && progressCallback) progressCallback()
    }, 2000);

    const response = await fetch(`/qPublishTranscriptDraft`, {
        method: "POST",
        headers: getHeaderG(trnscptPbls.loggedInUser),
        body: JSON.stringify({
            content: trnscptPbls.transcript,
            containername: trnscptPbls.transcriptName,
            userid: trnscptPbls.loggedInUser.userId,
            transcriptkey: trnscptPbls.transcriptKey,
            groupid: trnscptPbls.selectedGroup.selectionId,
            companyid: trnscptPbls.selectedGroup.companyid,
            sectionoverlap: trnscptPbls.selectedGroup.sectionoverlap,
            maxsectionlength: trnscptPbls.selectedGroup.maxsectionlength,
            sentencesearchlimit: trnscptPbls.selectedGroup.sentencesearchlimit,
            invoicesgroup: trnscptPbls.selectedGroup.invoicesgroup,
            usedocintel: trnscptPbls.selectedGroup.usedocintel,
            forceocr: trnscptPbls.selectedGroup.forceocr,
            assitanttype: trnscptPbls.selectedGroup.assistanttype,
            contenttype_config: trnscptPbls.selectedGroup.contenttype_config,
            aiquestionslang: trnscptPbls.selectedGroup.aiquestionslang,
            urllinkextraction: trnscptPbls.selectedGroup.urllinkextraction,
            perchunkmeta: trnscptPbls.selectedGroup.perchunkmeta,
            convo_config: trnscptPbls.selectedGroup.convo_config,
            oid: trnscptPbls.selectedGroup.oid
        })
    });
    let isRequestFinished = false;

    if (!response.ok) console.log(`Uploading_Files_Failed: ${response.statusText}`);

    const dataResponse: any = await response.json();
    import.meta.env.DEV === true && console.log("pldFlAp¦Init_Response4", dataResponse);

    const taskId = dataResponse.task_id;
    let taskCompleted = false;
    let taskResult = false;
    let taskMessage = "";
    let taskMessagePrev = "-1";
    let itterCounter = 0;

    while (!taskCompleted) {
        itterCounter++;
        // publishTranscriptDraft
        await wait(8000);
        const chkResp = await fetchTaskStatus(taskId);

        import.meta.env.DEV === true && console.log("pldFlAp¦Next_Response", chkResp);

        if (chkResp.status == "success" || chkResp.status == "partial" || chkResp.status == "error") {
            if (chkResp.status == "success" || chkResp.status == "partial") {
                taskResult = true;
                taskMessage = chkResp.message;
            } else {
                taskResult = false;
                taskMessage = chkResp.message;
            }
            taskCompleted = true;
            toast.update(toastId, {
                render: chkResp.message,
                autoClose: 7000
            });
        } else {
            if (chkResp.filecount !== undefined) {
                try {
                    let progress = chkResp.progresscount / chkResp.filecount;
                    taskMessage = `Processing Files... ${chkResp.progresscount} of ${chkResp.filecount} Done`;
                    toast.update(toastId, {
                        render: taskMessage
                    });
                } catch {
                    taskMessage = `Processing Files... ${chkResp.progresscount} of ${chkResp.filecount} Done`;
                    toast.update(toastId, {
                        render: taskMessage
                    });
                }
            }

            if (itterCounter % 2 === 0 || itterCounter % 10 === 5 || itterCounter < 5) if (progressCallback) progressCallback();

        }
        if (taskMessagePrev !== taskMessage && progressCallback) progressCallback();
        taskMessagePrev = taskMessage;
    }
    removeTaskIdFromLocal(taskId);
    const uplResponse: IUploadResponse = { success: taskResult, message: taskMessage };
}

export async function getTranscriptionDrafts(selectedGroup: gselectedgroup, loggedInUser: gloggedinuser, transcriptkey?: string): Promise<gtranscriptobject[]> {
    const params = new URLSearchParams({
        groupid: selectedGroup.selectionId,
        userid: loggedInUser.userId,
        transcriptkey: transcriptkey ? transcriptkey : ""
    });
    const url = "/qGetTranscriptionDrafts" + `?${params.toString()}`;

    const response = await fetch(url, {headers: {"Content-Type": "application/json"}});

    if (!response.ok) console.log("Failed to Validate Mail");

    let userCheck = await response.json();
    return userCheck;
}

export async function deleteTranscriptionDraft(selectedGroup: gselectedgroup, loggedInUser: gloggedinuser, transcriptKey: string) {
    await fetch(`/qDeleteTranscriptionDraft`, {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify({
            groupid: selectedGroup.selectionId,
            userid: loggedInUser.userId,
            transcriptKey: transcriptKey
        })
    });
}

export async function sync_spo_content(selectedGroup: gselectedgroup, loggedInUser: gloggedinuser) {
    let headers = getHeaderGS(loggedInUser, selectedGroup);
    await fetch(`/sync_spo_content`, {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            backdays: 0,
            delay_sec: 10
        })
    });
}

export async function ai_comparison(
    fid1: string,
    fid2: string,
    loggedInUser: gloggedinuser,
    compid: string,
    mod1: string,
    mod2: string,
    ownerid1: string,
    ownerid2: string,
    progressCallback?: (fileids?: string) => void
) {
    const toastId = toast.loading("Processing...", { autoClose: false });
    setTimeout(() => {
        if (progressCallback) progressCallback();
    }, 1000);

    const response = await fetch("/ai_compare", {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify({
            fid1: fid1,
            fid2: fid2,
            compid: compid,
            mod1: mod1,
            mod2: mod2,
            ownerid1: ownerid1,
            ownerid2: ownerid2
        })
    });
    toast.update(toastId, { render: "Comparing...", autoClose: false });
    const dataResponse: any = await response.json();
    const taskId = dataResponse.task_id;
    const wait = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
    const diffTaskStatus = async (taskId: string) => {
        const statusResponse = await fetch(`/task-status/${taskId}`);
        if (!statusResponse.ok) console.log(`Fetching Task Status Failed: ${statusResponse.statusText}`);

        return await statusResponse.json();
    };
    let taskCompleted = false;
    let taskResult = false;
    let taskMessage = "";

    while (!taskCompleted) {
        await wait(3000);
        const chkResp = await diffTaskStatus(taskId);

        if (chkResp.status == "success" || chkResp.status == "partial" || chkResp.status == "error") {
            if (chkResp.status == "success" || chkResp.status == "partial") {
                taskResult = true;
                taskMessage = chkResp.message;
                if (progressCallback) progressCallback();
            } else {
                taskResult = false;
                taskMessage = chkResp.message;
            }
            taskCompleted = true;
            toast.update(toastId, {
                render: chkResp.message,
                type: "success",
                autoClose: 2000,
                isLoading: false
            });
        } else {
            import.meta.env.DEV === true && console.log("Toast", `Deleting File...`);
            if (progressCallback) progressCallback();

            toast.update(toastId, {
                render: chkResp.message,
                isLoading: false
            });
        }
    }

    const uplResponse: IUploadResponse = { success: taskResult, message: taskMessage };
    return uplResponse;
}

export async function getAiDiff(fid1: string, fid2: string, loggedInUser: gloggedinuser): Promise<gdiffresponse[]> {
    const params = new URLSearchParams({
        fid1: fid1,
        fid2: fid2,
        userid: loggedInUser.userId
    });
    const url = "/qGetAIDiff" + `?${params.toString()}`;
    const response = await fetch(url, {
        headers: getHeaderG(loggedInUser)
    });
    if (!response.ok) console.log("Failed to Get AI Diff");
    let aiDiff = await response.json();
    return aiDiff;
}

export const qGetCompFlatList = async (headers: any) => {
    const response = await fetch("/qGetCompFlatList", { headers: headers });
    if (!response.ok) console.log("Failed to Get User Companies");
    let compList = await response.json();
    import.meta.env.DEV === true && console.log("‹comp_list›", compList);
    return compList;
};

export const qGetGroups = async (companyid: string, headers: any) => {
    const params = new URLSearchParams({ compd: companyid });
    const url = "/qGetGroups" + `?${params.toString()}`;
    const response = await fetch(url, { headers: headers });
    if (!response.ok) console.log("‹errr_get_groups›");
    let grpsresp = await response.json();
    return grpsresp;
};

export const downloadPDF = async (url: string, filename: string, companyId: string, loggedInUser: gloggedinuser, rekey?: string): Promise<void> => {
    try {
        const response = await fetch(`/content/${companyId}/${url}`, {
            method: "GET",
            headers: getHeaderG(loggedInUser, undefined, rekey)
        });

        if (!response.ok) throw new Error(`HTTP error ${response.status}`);

        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.style.display = "none";
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        // defer revoke to give download time to start
        setTimeout(() => {
            window.URL.revokeObjectURL(blobUrl);
        }, 3000);
    } catch (error) {
        console.error("Download failed:", error);
    }
};

export const getThumb = async (of: string, fid: string, company_id: string, loggedInUser: gloggedinuser) => {
    const params = new URLSearchParams({
        of: of,
        fid: fid,
        company_id: company_id
    });
    const url = "/thumb" + `?${params.toString()}`;
    fetch(url, { method: "GET", headers: getHeaderG(loggedInUser) })
        .then(response => response.blob())
        .then(blob => {})
        .catch(error => console.error("Download failed:", error));
};

export const qGetChatLog = async (groupid: string, headers: any) => {
    const params = new URLSearchParams({ groupid: groupid });
    const url = "/qGetChatLog" + `?${params.toString()}`;
    const response = await fetch(url, { headers: headers });
    if (!response.ok) console.log("qGetChatLog¦Failed to Get Log");
    let rsp = await response.json();
    rsp = rsp.map((item: any) => {
        return {
            ...item,
            datestamp: new Date(item.key).toLocaleString()
        };
    });

    let sChatLog: gChatlogItem[] = rsp;
    return sChatLog;
};

export const qGetCompLog = async (coid: string, headers: any) => {
    const params = new URLSearchParams({ coid: coid });
    const url = "/qGetCompLog" + `?${params.toString()}`;
    const response = await fetch(url, { headers: headers });
    if (!response.ok) console.log("qGetCompLog¦Failed to Get Log");
    let rsp = await response.json();
    rsp = rsp.map((item: any) => {
        return {
            ...item,
            datestamp: new Date(item.key).toLocaleString()
        };
    })
    let sChatLog: gComplogItem[] = rsp;
    return sChatLog;
};



// LINK app/backend/qp.py#licState
export const getLicState = async (coid: string, headers: any): Promise<gLicense[]> => {
    const params = new URLSearchParams({ coid: coid });
    const url = "/licState" + `?${params.toString()}`;
    const response = await fetch(url, { headers: headers });
    if (!response.ok) {
        console.log("‹errr_lic_state›");
        return [];
    }
    const rsp = await response.json();
    return rsp as gLicense[];
};



// LINK app/backend/qp.py#licStateUsage
export const getLicStateUsage = async (coid: string, headers: any): Promise<gLicense[]> => {
    const params = new URLSearchParams({ coid: coid });
    const url = "/licStateUsage" + `?${params.toString()}`;
    const response = await fetch(url, { headers: headers });
    if (!response.ok) {
        console.log("‹errr_lic_state_usage›");
        return [];
    }
    const rsp = await response.json();
    import.meta.env.DEV === true && console.log('‹lic_state_usage›', rsp);

    return rsp as gLicense[];
};



export const qHistGetByKey = async (userid: string, key: string, headers: any, initial_key?: string) => {
    let params = new URLSearchParams({ userid: userid, key: key });;
    if (initial_key) params = new URLSearchParams({ userid: userid, key: key, initial_key: initial_key });

    const url = "/qHistGetByKey" + `?${params.toString()}`;
    const response = await fetch(url, { headers: headers });
    if (!response.ok) console.log("Failed to Get Latest History");
    let keyConvo = await response.json();
    return keyConvo;
};

export const qHistGetRecent = async (userid: string, company: string, headers: any) => {
    const params = new URLSearchParams({ userid: userid, company: company });
    const url = "/qHistGetRecent" + `?${params.toString()}`;
    const response = await fetch(url, { headers: headers });
    if (!response.ok) console.log("Failed to Get Latest History");
    let recentConvosUserWide = await response.json();
    return recentConvosUserWide;
};

export const qGetSuggestedQuestions = async (fLst: gfile[], headers: any) => {
    const params = new URLSearchParams({
        fileids: fLst
            .map(f => f.fileid)
            .sort(() => 0.5 - Math.random())
            .slice(0, 3)
            .join(",")
    });
    const url = "/qGetSuggestedQuestions" + `?${params.toString()}`;
    const response = await fetch(url, { headers: headers });
    if (!response.ok) console.log("Failed to Get Suggested Questions");
    let suggestedQuestions = await response.json();
    return suggestedQuestions;
};

export const qHistGetLatest = async (userid: string, groupid: string, companyid: string, topn: number, headers: any) => {
    const params = new URLSearchParams({
        userid: userid,
        groupid: groupid,
        companyid: companyid,
        topn: topn.toString()
    });
    const url = "/qHistGetLatest" + `?${params.toString()}`;
    const response = await fetch(url, { headers: headers });
    if (!response.ok) console.log("Failed to Get Latest History");
    let latestConvo = await response.json();
    return latestConvo;
};

export const qCodeChk = async (userCode: string, userMail: string, mE: string, convCode?: string) => {
    const params = new URLSearchParams({
        userCode: userCode,
        userMail: userMail,
        convCode: convCode || "",
        mE: mE
    });
    const url = "/qCodeChk" + `?${params.toString()}`;
    const response = await fetch(url, { headers: { "Content-Type": "application/json" } });
    if (!response.ok) console.log("Failed to Validate Mail");
    let userCheck = await response.json();
    return userCheck;
};

export const qUSp = async (n: string, v: string, headers: any) => {
    try {
        let subpaths = window.location.hash.split("/").filter(Boolean);
        let groupPath = decodeURIComponent(subpaths[2]);
        fetch("/qUSp", {
            method: "POST",
            headers: headers,
            body: JSON.stringify({ grpi: groupPath, n: n, v: v })
        }).then(Response => {
            window.location.href = `${window.location.href.replace("chat", "library")}`;
            window.location.reload();
        });
    } catch {
        import.meta.env.DEV === true && console.log("errr_qusp");
    }
};

export const upsertGroup = async (rheader: any, editedSpace: gselectedgroup, instaOptions?: SaveOptions) => {
    try {
        await fetch("/qAddGroup", {
            method: "POST",
            headers: rheader,
            body: JSON.stringify({
                groupid: editedSpace.selectionId,
                groupname: editedSpace.selectionText,
                companyid: "", // doesnt matter, upsert will ignore it
                description: editedSpace.description,
                custaiinst: editedSpace.custaiinst,
                sharewithcode: instaOptions?.sharewithcode ?? editedSpace.sharewithcode,
                custgreetingmessage: editedSpace.custgreetingmessage,
                isintegrateddata: editedSpace.isintegrateddata,
                allowyoutube: editedSpace.allowyoutube,
                allowweb: editedSpace.allowweb,
                enabledocaudio: editedSpace.enabledocaudio,
                retrievecount: editedSpace.retrievecount,
                sectionoverlap: editedSpace.sectionoverlap,
                maxsectionlength: editedSpace.maxsectionlength,
                sentencesearchlimit: editedSpace.sentencesearchlimit,
                inscope: editedSpace.inscope,
                temperature: editedSpace.temperature,
                responsetokenlimit: editedSpace.responsetokenlimit,
                disablecitationhighlighting: editedSpace.disablecitationhighlighting,
                strictness: editedSpace.strictness,
                invoicesgroup: editedSpace.invoicesgroup,
                questionsuggestions: editedSpace.questionsuggestions,
                nosidebysideview: editedSpace.nosidebysideview,
                showexamplequestionsonstart: editedSpace.showexamplequestionsonstart,
                headerimageurl: instaOptions?.headerimageurl ?? editedSpace.headerimageurl,
                manualquestionsuggestions: editedSpace.manualquestionsuggestions,
                usedocintel: editedSpace.usedocintel,
                allowaudiodocentry: editedSpace.allowaudiodocentry,
                forceocr: editedSpace.forceocr,
                allowvideofiles: editedSpace.allowvideofiles,
                convomode: editedSpace.convomode,
                convolang: editedSpace.convolang,
                hideaisearch: editedSpace.hideaisearch,
                urllinkextraction: editedSpace.urllinkextraction,
                docextractionuseauto: editedSpace.docextractionuseauto,
                spo_config: editedSpace.spo_config,
                line_config: editedSpace.line_config,           // ℹ️ Line configuration for document extraction
                aiquestionslang: editedSpace.aiquestionslang,
                perchunkmeta: editedSpace.perchunkmeta,
                pdfcontentlist: editedSpace.pdfcontentlist,
                showchartsinuni: editedSpace.showchartsinuni,
                usenewmodel: editedSpace.usenewmodel,
                uselatestretrieval: editedSpace.uselatestretrieval,
                allowaudiofiles: editedSpace.allowaudiofiles,
                landonmanage: editedSpace.landonmanage,
                viewerscanupload: editedSpace.viewerscanupload,
                hideroottabs: editedSpace.hideroottabs,
                dontloadlastconvo: editedSpace.dontloadlastconvo,
                allowsimpleconvo: editedSpace.allowsimpleconvo,
                allowgroupconnect: editedSpace.allowgroupconnect,
                campaigns_enabled: editedSpace.campaigns_enabled,
                def_campaign_id: editedSpace.def_campaign_id,
                gen_opt: editedSpace.gen_opt
            })
        });
    } catch {
        import.meta.env.DEV === true && console.log("‹errr_upsert_group›");
    }
};

export const qLi = async (cat: string, det: string, headers: any, usr?: string) => {
    try {
        fetch("/qLi", {
            method: "POST",
            headers: headers,
            body: JSON.stringify({
                usr: usr,
                cat: cat,
                det: det,
                loc: window.location.hash?.replace(/[^a-zA-Z0-9]/g, " ")
            })
        });
    } catch {
        // errr qLi
    }
};

export const qGetTiers = async (headers: any) => {
    const url = "/qGetTiers";
    const response = await fetch(url, { headers: headers });
    if (!response.ok) console.log("Failed to Get Latest History");
    let tiers = await response.json();
    return tiers;
};

export const qHistGetList = async (userid: string, groupid: string, companyid: string, topn: number, headers: any) => {
    const params = new URLSearchParams({
        userid: userid,
        groupid: groupid,

        companyid: companyid,
        topn: topn.toString()
    });
    const url = "/qHistGetList" + `?${params.toString()}`;
    const response = await fetch(url, { headers: headers });
    if (!response.ok) console.log("Failed to Get Latest History");
    let convos = await response.json();
    return convos;
};

export const qHistAdd = async (key: number, userid: string, groupid: string, companyid: string, name: string, headers: any, answrs: any) => {
    fetch("/qHistAdd", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            key: key,
            userid: userid,
            groupid: groupid,
            companyid: companyid,
            content: answrs,
            name: name
        })
    });
};

export const qRunInvVal = async (item: any, allowed_deviation: number) => {
    const response = await fetch('/qRunInvVal', {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
            item: item,
            allowed_deviation: allowed_deviation
        })
    });

    if (!response.ok) return {success: false, response: "Failed qRunInvVal"};

    return await response.json();
};

export const qGetGroupsMemberships = async (companyid: string, headers: any) => {
    const params = new URLSearchParams({ compd: companyid });
    const url = "/qGetGroupsMemberships" + `?${params.toString()}`;
    const response = await fetch(url, { headers: headers });
    if (!response.ok) console.log("Failed to get Groups");
    let mbrshpsResp = await response.json();
    return mbrshpsResp;
};

export const qGetCompanyUsers = async (companyid: string, headers: any) => {
    const params = new URLSearchParams({ compd: companyid });
    const url = "/qGetCompanyUsers" + `?${params.toString()}`;
    const response = await fetch(url, { headers: headers });
    if (!response.ok) console.log("Failed to Get User Info");
    let compUsers = await response.json();
    return compUsers;
};

export const qGetAllUsers = async (headers: any) => {
    const response = await fetch("/qGetAllUsers", { headers: headers });
    if (!response.ok) console.log("Failed to Get User Info");
    let allUsers = await response.json();
    return allUsers;
};

// ANCHOR[id=qGetFileParagrapsJS] 🗃️ get file paragraphs
// LINK app/backend/qp.py#qGetFileParagraps
export const qGetFileParagraps = async (fid: string, loggedInUser: gloggedinuser): Promise<gautoparagraphresult[]> => {
    import.meta.env.DEV === true && console.log("‹qget_para›", fid);
    const params   = new URLSearchParams({ fid: fid });
    const url      = "/qGetFileParagraps" + `?${params.toString()}`;
    const response = await fetch(url, { headers: getHeaderG(loggedInUser) });

    if (!response.ok) console.log("‹errr_get_para›");

    let paragrps = await response.json();
    if (paragrps && paragrps.length > 0) paragrps = paragrps;
    import.meta.env.DEV === true && console.log("‹fetched_paragraphs›", paragrps);

    return paragrps;
};


// ANCHOR[id=qResolveParagraphHighlightJS] 🎯 resolve an extracted value ⇒ paragraph kgnf_ids
// LINK app/backend/qp.py#qResolveParagraphHighlight
export interface gparagraphhighlightresult {
    kgnf_ids: number[];
    pages: number[];
    matched: boolean;
}
export const qResolveParagraphHighlight = async (
    fid: string,
    value: string,
    stype: string,
    loggedInUser: gloggedinuser
): Promise<gparagraphhighlightresult> => {
    const empty: gparagraphhighlightresult = { kgnf_ids: [], pages: [], matched: false };
    try {
        const response = await fetch("/qResolveParagraphHighlight", {
            method: "POST",
            headers: { ...getHeaderG(loggedInUser), "Content-Type": "application/json" },
            body: JSON.stringify({ fid, value, stype })
        });
        if (!response.ok) {
            console.log("‹errr_resolve_para_hl›");
            return empty;
        }
        const res = await response.json();
        return res && typeof res === "object" ? { ...empty, ...res } : empty;
    } catch {
        console.log("‹errr_resolve_para_hl_catch›");
        return empty;
    }
};



export const qGetGroupLastModifiedFileDate = async (groupid: string, headers: any) => {
    const params = new URLSearchParams({ groupid: groupid });
    const url = "/qGetLatestModified" + `?${params.toString()}`;
    const response = await fetch(url, { headers: headers });
    if (!response.ok) console.log("‹q_last_mod_no_response›");
    let modresp = await response.json();
    return modresp;
};

// successor to qGetGroupLastModifiedFileDate
export const qGetLastModV2 = async (gid: string, hdrs: any): Promise<livecachemap> => {
    const params = new URLSearchParams({ groupid: gid });
    const url = "/qGetLatestModified_v2" + `?${params.toString()}`;
    const response = await fetch(url, { headers: hdrs });
    if (!response.ok) console.log("‹q_last_mod_v2›");
    let modresp: livecachemap = new Map(
        (await response.json() || []).map((item: any) => [
            parseInt(item.fileid),
            {
                fileid: parseInt(item.fileid),
                modified: strToDate(item.modified),
                docstatus: item.docstatus
            }
        ])
    );
    return modresp;
};

// LINK app/backend/qp.py#qAddMember
export const qAddMember = async (usermail: string, groupid: string, compid: string, headers: any, sendmail?: boolean, groupname?: string) => {
    const response = await fetch("/qAddMember", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            usermail: usermail,
            level: 1,
            groupid: groupid,
            companyid: compid,
            sendmail: sendmail || false,
            groupname: groupname || "",
            kgnfdom: window.location.host
        })
    });
    return response;
};

export const qHistEditName = async (key: string, newText: string, userid: string, headers: any) => {
    const response = await fetch("/qHistEditName", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            key: key,
            userid: userid,
            name: newText
        })
    });
    return response;
};

export const qHistDelete = async (key: string, userid: string, headers: any) => {
    const response = await fetch("/qHistDelete", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            key: key,
            userid: userid
        })
    });
    return response;
};

export const qGetSentenceState = async (sentence: string, prev: string, selectedGroud: gselectedgroup, conf_name: string) => {
    const params = new URLSearchParams({
        user_msg: sentence,
        prev_msg: prev,
        cust_inst: JSON.stringify(selectedGroud.docextractionconfig || []),
        conf_name: conf_name
    });
    const url = "/kgnf_sentence_state" + `?${params.toString()}`;
    const response = await fetch(url, {
        headers: {
            space_id: selectedGroud.selectionId,
            company_id: selectedGroud.companyid
        }
    });
    if (!response.ok) console.log("Failed to Get Sentence State");
    let sentence_state = await response.json();
    return sentence_state;
};

export const qGetMatching = async (sentence: string, prev: string, option_values: string, option_config: gjsonprop, selectedGroup: gselectedgroup) => {
    const params = new URLSearchParams({
        user_msg: sentence,
        prev_msg: prev,
        option_values: option_values,
        option_config_name: option_config.name,
        option_config_desc: option_config.description
    });
    const url = "/kgnf_ai_matching" + `?${params.toString()}`;
    const response = await fetch(url, {
        headers: {
            space_id: selectedGroup.selectionId,
            company_id: selectedGroup.companyid
        }
    });
    if (!response.ok) console.log("Failed to Get Sentence State");
    let sentence_state = await response.json();
    return sentence_state;
};

export const qTopicChange = async (
    sentence: string,
    prev: string,
    prev_topic: string,
    question_and_answers_list: gqasimplified[],
    selectedGroup: gselectedgroup,
    conf_details: gjsonprop
) => {
    const params = new URLSearchParams({
        user_msg: sentence,
        prev_msg: prev,
        prev_topic: prev_topic,
        qa_list: JSON.stringify(question_and_answers_list),
        conf_details: JSON.stringify(conf_details)
    });
    const url = "/kgnf_ai_topic_change" + `?${params.toString()}`;
    const response = await fetch(url, {
        headers: {
            space_id: selectedGroup.selectionId,
            company_id: selectedGroup.companyid
        }
    });

    if (!response.ok) console.log("Failed to Get Sentence State");
    let sentence_state = await response.json();
    console.log('sentence_state', sentence_state);
    return sentence_state;
};

export const qAiTopicChangeV2 = async (
    message: string,
    prev: string,
    prev_topic: string,
    qa_list: any[],
    confDetails: any,
    selectedGroup: gselectedgroup,
    streamId: string,
    choices: any = null,
    model: string = "gpt-4.1-nano"
) => {
    const body = {
        message: message,
        prev: prev,
        prev_topic: prev_topic,
        qa_list: qa_list,
        conf_details: confDetails,
        category: selectedGroup?.selectionId,
        streamId: streamId,
        model: model,
        choices: choices
    };

    const response = await fetch("/kgnf_ai_topic_change", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            space_id: selectedGroup.selectionId,
            company_id: selectedGroup.companyid
        },
        body: JSON.stringify(body)
    });

    if (!response.ok) console.log("Failed to call AI Topic Change");

    const result = await response.json();
    console.log("💬 AI Topic Change result:", result);

    return {
        value_ok: result?.value_ok ?? false,
        requested_value: result?.requested_value ?? "",
        is_different_direction: result?.is_different_direction ?? false,
        user_asks_or_requests: result?.user_asks_or_requests ?? false
    };
};

export const qReadify = async (text: string, selectedGroup: gselectedgroup) => {
    const params = new URLSearchParams({ text: text });
    const url = "/kgnf_readify" + `?${params.toString()}`;
    const response = await fetch(url, {
        headers: {
            space_id: selectedGroup.selectionId,
            company_id: selectedGroup.companyid
        }
    });

    if (!response.ok) console.log("Failed to Get Sentence State");
    let readify = await response.json();
    console.log("readify", readify);
    console.log("readify", readify.result);
    if (readify && readify.result && readify.result.reply) {
        console.log("returns", readify.result.reply);
        return readify.result.reply;
    } else {
        return text;
    }
};

export const reRunPreconfAnalysis = async (inv_res: IObjectWithKey[], preconfopt: string, headers: any, selectedGroup: gselectedgroup) => {
    inv_res.map(item => {
        let inv_data = (item as any)["invoicedata"];
        let fid = (item as any)["key"];
        console.log("inv_data", item);
        const response = fetch("/kgnf_predef", {
            method: "POST",
            headers: headers,
            body: JSON.stringify({
                inv_res: inv_data,
                preconfopt: preconfopt,
                groupid: selectedGroup.selectionId,
                fid: fid
            })
        });
        return response;
    });
};

export const qJsonAnalysis = async (json_arr: gfanalyse[], headers: any, fids: string[], groupid: string) => {
    const response = await fetch("/kgnf_json_analysis", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            json_arr: json_arr,
            fids: fids,
            groupid: groupid
        })
    });
    if (!response.ok)
        return {
            success: false,
            response: "Failed to Analyse JSON"
        };
    return await response.json();
};

export const qJsonAnalysisRecall = async (aiiid: string, doc_cat: string, headers: any, groupid: string, fid: string) => {
    let url = "/kgnf_json_analysis_recall";
    const params = new URLSearchParams({
        aiiid: aiiid,
        groupid: groupid,
        doc_cat: doc_cat,
        fid: fid
    });
    url += `?${params.toString()}`;
    const response = await fetch(url, {
        method: "GET",
        headers: headers
    });
    if (!response.ok)
        return {
            success: false,
            response: "Failed to Analyse JSON"
        };
    return await response.json();
};

export const qJsonAnalysisRemove = async (aiinteractionid: string, headers: any, groupid: string) => {
    const response = await fetch("/kgnf_json_analysis_remove", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            aiinteractionid: aiinteractionid,
            groupid:  groupid
        })
    });
    if (!response.ok)
        return {
            success: false,
            response: "Failed to Remove JSON"
        };
};

export const qJsonAnalysisRecallPredef = async (headers: any, groupid: string) => {
    let url = "/kgnf_json_analysis_recall_predef";
    const params = new URLSearchParams({
        groupid: groupid
    });
    url += `?${params.toString()}`;
    const response = await fetch(url, {
        method: "GET",
        headers: headers
    });
    if (!response.ok)
        return {
            success: false,
            response: "Failed to Analyse JSON"
        };
    return await response.json();
};

export const qRamJet = async (main_state: any, stream_sid: string, exp_resp_type: string, msg: any, selectedGroup: gselectedgroup) => {
    const body = {
        main_state,
        stream_sid,
        exp_resp_type,
        msg
    };

    const response = await fetch("/ai_ram_jet", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            space_id: selectedGroup.selectionId,
            company_id: selectedGroup.companyid
        },
        body: JSON.stringify(body)
    });

    if (!response.ok) console.log("Failed to call RAM JET");
    let result: any = {};
    try {
        result = await response.json();
    } catch (error) {
        console.error("Error parsing RAM JET response:", error, response);
        result = {
            value_ok: false,
            requested_value: "",
            is_different_direction: false,
            user_asks_or_requests: false
        };
    }
    console.log("💡 RAMJET result:", result);
    return result;
};

export const qAiMatching = async (
    message: string,
    prev: string,
    options: string,
    category: string,
    option_config_name: string,
    option_config_desc: string,
    model: string
) => {
    try {
        const response = await fetch("/kgnf_ai_matching_v2", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                message: message,
                prev: prev,
                options: options,
                category: category,
                option_config_name: option_config_name,
                option_config_desc: option_config_desc,
                model: model
            })
        });

        if (!response.ok) console.log(`Server error: ${response.status}`);

        const result = await response.json();
        console.log("✅ AI Matching Result:", result);
        return result;
    } catch (error) {
        console.error("❌ Error calling /kgnf_ai_matching_v2:", error);
        return null;
    }
};

export const qAddFeedbackDirect = async (userid: string, spaceid: string, content: string, headers: any) => {
    fetch("/qAddFeedbackDirect", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            userid: userid,
            spaceid: spaceid,
            content: content,
            eventwebsrc: getEncodedCurrentURL()
        })
    });
};

// LINK app/backend/qp.py#qGetSpaceFiles
export const qReqSpaceFiles = async (selectedGroup: gselectedgroup, companyId: string, setInitLoad: (val: boolean) => void, headersObj: any, updActionArrs?: livecacheactions, filtFidStr?: string, dateRange?: { start?: Date; end?: Date }): Promise<any[]> => {
    const params = new URLSearchParams({
        grouptype: selectedGroup.assistanttype,
        groupid: selectedGroup.selectionId,
        groupname: selectedGroup.selectionText,
        isinvoicegroup: selectedGroup.invoicesgroup == 1 ? "yes" : "no",
        companyid: companyId,
        pe: selectedGroup.viewerscanupload == 1 ? "1" : "0",
        ...((updActionArrs && updActionArrs.forRefresh.size > 0 && updActionArrs && updActionArrs.forRefresh.size < 1000) ? { updFidsStr: Array.from(updActionArrs.forRefresh.keys()).join(";") } : '')
    });
    // date range filter (mutually exclusive with updFidsStr on the backend)
    if (dateRange?.start && dateRange?.end) {
        const fmt = (d: Date) => `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}${String(d.getDate()).padStart(2, '0')}`;
        params.set('dateStart', fmt(dateRange.start));
        params.set('dateEnd',   fmt(dateRange.end));
    }
    const resp = await fetch('/qGetSpaceFiles' + `?${params.toString()}`, { headers: headersObj });
    if (!resp.ok) setInitLoad(false);
    let flResp = await resp.json();
    return flResp;
}

// LINK app/backend/qp.py#qReqSpaceFiles
export const qReqSpaceFilesPost = async (selectedGroup: gselectedgroup, companyId: string, setInitLoad: (val: boolean) => void, headersObj: any, updActionArrs?: livecacheactions, filtFidStr?: string, dateRange?: { start?: Date; end?: Date }): Promise<any[]> => {
    const body: any = {
        grouptype: selectedGroup.assistanttype,
        groupid: selectedGroup.selectionId,
        groupname: selectedGroup.selectionText,
        isinvoicegroup: selectedGroup.invoicesgroup == 1 ? "yes" : "no",
        companyid: companyId,
        pe: selectedGroup.viewerscanupload == 1 ? "1" : "0",
    };
    if (updActionArrs && updActionArrs.forRefresh.size > 0 && updActionArrs.forRefresh.size < 20000) {
        body.updFidsStr = Array.from(updActionArrs.forRefresh.keys()).join(";");
    }
    // date range filter (mutually exclusive with updFidsStr on the backend)
    if (dateRange?.start && dateRange?.end) {
        const fmt = (d: Date) => `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}${String(d.getDate()).padStart(2, '0')}`;
        body.dateStart = fmt(dateRange.start);
        body.dateEnd   = fmt(dateRange.end);
    }
    const resp = await fetch('/qReqSpaceFiles', {
        method: "POST",
        headers: { ...headersObj, 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    });
    if (!resp.ok) setInitLoad(false);
    let flResp = await resp.json();
    return flResp;
}

export const qGetCCAOverviews = async (gid: string, loggedInUser: gloggedinuser): Promise<any[]> => {
    const params = new URLSearchParams({ groupid: gid });
    const url = "/qGetCCAOverviews" + `?${params.toString()}`;
    const response = await fetch(url, { headers: getHeaderG(loggedInUser) });
    if (!response.ok) console.log("‹q_last_mod_v2›");
    let convodata = await response.json();
    return convodata;
};

export const qGenChart = async (fidData: number[], userMsg: string, groupId: string, loggedInUser: gloggedinuser, chartType: string = 'chartjs'): Promise<any> => {
    const params = new URLSearchParams({
        fid_data: fidData.join(','),
        user_msg: userMsg,
        group_id: groupId,
        chart_type: chartType
    });
    const url = "/qGenChart" + `?${params.toString()}`;
    const response = await fetch(url, { headers: getHeaderG(loggedInUser) });
    if (!response.ok) {
        console.log("‹errr_gen_chart›");
        return null;
    }
    const chartResp = await response.json();
    // normalize backend payloads: either direct { chartjs_json } or wrapped { chart_result: { chartjs_json } }
    if (chartResp?.chart_result?.chartjs_json !== undefined) {
        return {
            ...chartResp,
            chartjs_json: chartResp.chart_result.chartjs_json
        };
    }
    return chartResp;
};

export const qUpdateFieldOrder = async (aiid: string, fieldorder: string[], loggedInUser: gloggedinuser): Promise<boolean> => {
    const response = await fetch("/qUpdateFieldOrder", {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify({ aiid, fieldorder })
    });
    return response.ok;
};

export const qUpdateAiContent = async (aiid: string, content: any, loggedInUser: gloggedinuser): Promise<boolean> => {
    const response = await fetch("/qUpdateAiContent", {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify({ aiid, content })
    });
    return response.ok;
};

export const qApplyFieldOrderByDocType = async (groupid: string, doc_type: string, fieldorder: string[], loggedInUser: gloggedinuser): Promise<boolean> => {
    const response = await fetch("/qApplyFieldOrderByDocType", {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify({ groupid, doc_type, fieldorder })
    });
    return response.ok;
};

export const qSaveFieldOrderByDocType = async (groupid: string, doc_type: string, fieldorder: string[], loggedInUser: gloggedinuser): Promise<boolean> => {
    const response = await fetch("/qSaveFieldOrderByDocType", {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify({ groupid, doc_type, fieldorder })
    });
    return response.ok;
};

export const qGetFieldOrderByDocType = async (groupid: string, doc_type: string, loggedInUser: gloggedinuser): Promise<string[] | null> => {
    const response = await fetch(`/qGetFieldOrderByDocType?groupid=${encodeURIComponent(groupid)}&doc_type=${encodeURIComponent(doc_type)}`, {
        headers: getHeaderG(loggedInUser)
    });
    if (!response.ok) return null;
    const data = await response.json();
    return data.fieldorder ?? null;
};

export const qAddMmbr = async (owners: ownersProps[], nGroupId: string, activeComp: any, headers: any): Promise<Response> => {
    return fetch("/qAddMembership", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            usersArr: owners,
            groupId: nGroupId,
            companyid: activeComp.companyid
        })
    })
}
export const qEditComp = async (activeComp: any, editedComp: any, headers: any): Promise<Response> => {
    return fetch("/qEditComp", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            companyid: activeComp.companyid,
            licensingkind: editedComp.licensingkind,
            alloweddomains: editedComp.alloweddomains,
            allowqueststocreate: editedComp.allowqueststocreate
        })
    })
}


export const qAddExtraConf = async (nGroup: gnewgroup, headers: any): Promise<Response> => {
    return fetch("/qDocExtrConf", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            groupid: nGroup.id,
            docextractionconfig: nGroup?.specializedSettings?.docextractionconfig,
            docextractionuseauto: nGroup?.specializedSettings?.docextractionuseauto,
            custaiinst: nGroup?.specializedSettings?.custaiinst,
            convo_config: nGroup?.specializedSettings?.convo_config
        })
    })
}

export const qAddGrp = async (nGroup: gnewgroup, activeCompId: string, custaiinst: string, custgreetingmessage: string, headers: any): Promise<Response> => {
    return fetch("/qAddGroup", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            groupid: nGroup.id,
            groupname: nGroup.groupname,
            companyid: activeCompId,
            description: nGroup.description,
            sharewithcode: 0,
            custaiinst: custaiinst,
            custgreetingmessage: custgreetingmessage,
            isintegrateddata: true,
            appid: nGroup.appid,
            scrt: nGroup.scrt,
            isnew: true,
            ...nGroup.specializedSettings
        })
    })
}